import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle } from "@/components/ui/card";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Input } from "@/components/ui/input";
import { ExternalLink, MoreHorizontal, Pen, Trash } from "lucide-react";
import React, { useState } from "react";
import VersionHistoryItemChanges from "./VersionHistoryItemChanges";
const EditableTitle = ({
  id,
  name: initialName,
  createdAt,
  onDelete,
  parentRef,
  onLoadVersion,
}) => {
  const [editedTitle, setEditedTitle] = useState(initialName);
  const [name, setName] = useState(initialName);
  const [isEditing, setIsEditing] = useState(false);

  return (
    <CardHeader className="flex pt-2 pb-2 bg-transparent rounded-md hover:bg-muted cursor-pointer">
      <div className="flex flex-col items-start w-full">
        {isEditing ? (
          <div className="flex items-center gap-2 w-full">
            <Input
              value={editedTitle}
              onChange={(e) => setEditedTitle(e.target.value)}
              className="h-8 border-0 border-b rounded-none"
            />
            <Button
              size="xs"
              variant="borderless"
              onClick={() => {
                setName(editedTitle);
                setIsEditing(false);
              }}
            >
              Save
            </Button>
          </div>
        ) : (
          <div className="flex items-center justify-between w-full">
            <div className="flex flex-col">
              <CardTitle className="text-md font-normal">#{name}</CardTitle>
              <span className="text-xs text-gray-400 uppercase">
                {new Date(createdAt).toLocaleString()}
              </span>
            </div>
          </div>
        )}
      </div>
      {!isEditing && (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              className="rounded-lg bg-transparent ml-auto"
            >
              <MoreHorizontal className="size-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            align="end"
            className="flex flex-col justify-start items-start"
          >
            <Button
              variant="borderless"
              className="w-full text-secondary flex items-center justify-start hover:text-white"
              onClick={() => onLoadVersion()}
            >
              <ExternalLink size={24} />
              Load
            </Button>

            <VersionHistoryItemChanges parentRef={parentRef} />
            <Button
              variant="borderless"
              className="w-full text-secondary flex items-center justify-start hover:text-white"
              onClick={() => {
                setEditedTitle(name);
                setIsEditing(true);
              }}
            >
              <Pen size={24} />
              Edit Name
            </Button>
            <Button
              variant="borderless"
              className="w-full text-secondary flex items-center justify-start hover:text-red-500"
            >
              <Trash size={24} />
              Delete
            </Button>
          </DropdownMenuContent>
        </DropdownMenu>
      )}
    </CardHeader>
  );
};

const VersionHistoryItem = ({
  id,
  name,
  createdAt,
  onViewChangeLog,
  parentRef,
  onLoadVersion,
}) => {
  return (
    <div className="group">
      <Card
        className="rounded m-3 
                  overflow-hidden
                  border-0
                  bg-transparent
                  "
      >
        <EditableTitle
          name={name}
          createdAt={createdAt}
          parentRef={parentRef}
          onDelete={() => alert("Deleting")}
          onLoadVersion={onLoadVersion}
        />
      </Card>
    </div>
  );
};
export default VersionHistoryItem;
